<template>
  <div class="order-items">
    <form method="post" accept-charset="UTF-8" action="">
      <input type="hidden" :name="order.tokenName" :value="order.token">
      <input type="hidden" name="orderId" :value="order.id">
      <input type="hidden" name="redirect" value="">

      <div class="allocated-breakdown py-4 mx-4">
        <div class="toggle flex justify-center mb-4">
          <button @click.prevent="toggleAllocated = !toggleAllocated" v-show="showAllocatedBtn" class="rounded-full flex items-center text-base text-white border border-light-grey shadow-solid bg-green py-2 px-4 uppercase">
            View allocated breakdown
          </button>
        </div>

        <div class="table bg-light-grey rounded-lg shadow p-4">
          <div class="head grid grid-cols-12">
            <div class="col-span-4 p-2">
              <p class="bg-gray-50 text-left text-xs leading-4 font-bold text-gray-500 uppercase tracking-wider">Product Name</p>
            </div>

            <div class="col-span-3 p-2">
              <p class="bg-gray-50 text-left text-xs leading-4 font-bold text-gray-500 uppercase tracking-wider">Vendor</p>
            </div>
            
            <div class="col-span-2 p-2">
              <p class="bg-gray-50 text-left text-xs leading-4 font-bold text-gray-500 uppercase tracking-wider">Ordered</p>
            </div>
            
            <div class="col-span-2 p-2">
              <p class="bg-gray-50 text-left text-xs leading-4 font-bold text-gray-500 uppercase tracking-wider">Allocated</p>
            </div>
          </div>

          <div
            v-for="(item, index) in order.items"
            :key="index"
            class="body grid grid-cols-12"
          >
            <div class="col-span-4 p-2">
              <span class="text-sm leading-5 text-gray-900" v-html="item.title" />
            </div>

            <div class="col-span-3 p-2">
              <span class="text-sm leading-5 text-gray-900" v-html="item.vendor" />
            </div>
            
            <div class="col-span-2 p-2">
              <input
                :disabled="item.editing == false"
                type="number"
                class="border border-gray-200 p-2 rounded leading-tight w-20"
                :class="item.editing == false ? 'opacity-50 cursor-not-allowed' : ''"
                v-model="item.qty"
                min="1"
                :max="item.max"
              >
            </div>
            
            <div class="col-span-2 p-2">
              <input
                :disabled="true"
                type="number"
                class="border border-gray-200 p-2 rounded leading-tight w-20 opacity-50 cursor-not-allowed"
                v-model="item.allocated"
              >
            </div>

            <div class="actions col-span-1 flex justify-end">
              <button
                @click.prevent="item.editing = !item.editing"
                class="outline-none rounded-none"
              >
                <svg v-if="item.editing" class="w-6" viewBox="0 0 512 512"><path fill="#009044" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 464c-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216zm94.8-285.3L281.5 256l69.3 69.3c4.7 4.7 4.7 12.3 0 17l-8.5 8.5c-4.7 4.7-12.3 4.7-17 0L256 281.5l-69.3 69.3c-4.7 4.7-12.3 4.7-17 0l-8.5-8.5c-4.7-4.7-4.7-12.3 0-17l69.3-69.3-69.3-69.3c-4.7-4.7-4.7-12.3 0-17l8.5-8.5c4.7-4.7 12.3-4.7 17 0l69.3 69.3 69.3-69.3c4.7-4.7 12.3-4.7 17 0l8.5 8.5c4.6 4.7 4.6 12.3 0 17z"/></svg>
                <svg v-else class="w-6" viewBox="0 0 576 512"><path fill="#f56565" d="M417.8 315.5l20-20c3.8-3.8 10.2-1.1 10.2 4.2V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h292.3c5.3 0 8 6.5 4.2 10.2l-20 20c-1.1 1.1-2.7 1.8-4.2 1.8H48c-8.8 0-16 7.2-16 16v352c0 8.8 7.2 16 16 16h352c8.8 0 16-7.2 16-16V319.7c0-1.6.6-3.1 1.8-4.2zm145.9-191.2L251.2 436.8l-99.9 11.1c-13.4 1.5-24.7-9.8-23.2-23.2l11.1-99.9L451.7 12.3c16.4-16.4 43-16.4 59.4 0l52.6 52.6c16.4 16.4 16.4 43 0 59.4zm-93.6 48.4L403.4 106 169.8 339.5l-8.3 75.1 75.1-8.3 233.5-233.6zm71-85.2l-52.6-52.6c-3.8-3.8-10.2-4-14.1 0L426 83.3l66.7 66.7 48.4-48.4c3.9-3.8 3.9-10.2 0-14.1z"/></svg>
              </button>
            </div>

            <ul class="allocated-items col-span-11 col-start-2" v-show="toggleAllocated">
              <li
                v-for="(allocItem, index) in order.allocations"
                :key="index"
                  class="alloc-item my-5 bg-white rounded-lg shadow p-4"
              >
                <dl>
                  <div class="sm:grid sm:grid-cols-3 sm:gap-4 py-2">
                    <dt class="text-sm leading-5 font-bold text-gray-500">
                      Product Name
                    </dt>
                    <dd class="pt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
                      {{ allocItem.title }}
                    </dd>
                  </div>
                  
                  <div class="py-2 sm:grid sm:grid-cols-3 sm:gap-4">
                    <dt class="text-sm leading-5 font-bold text-gray-500">
                      Vendor
                    </dt>
                    <dd class="pt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2 sm:border-t sm:border-grey">
                      {{ item.vendor }}
                    </dd>
                  </div>

                  <div class="py-2 sm:grid sm:grid-cols-3 sm:gap-4">
                    <dt class="text-sm leading-5 font-bold text-gray-500">
                      Qty Allocated
                    </dt>
                    <dd class="pt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2 sm:border-t sm:border-grey">
                      {{ allocItem.qty }}
                    </dd>
                  </div>

                  <div class="py-2 sm:grid sm:grid-cols-3 sm:gap-4">
                    <dt class="text-sm leading-5 font-bold text-gray-500">
                      Ship To
                    </dt>
                    <dd class="pt-1 sm:mt-0 sm:col-span-2 sm:border-t sm:border-grey">
                      <p class="text-sm leading-5 text-black">{{ allocItem.shipTo.title }}</p>
                      <p class="text-sm leading-5 text-black">
                        {{ allocItem.shipTo.address }},<br>
                        {{ allocItem.shipTo.city }}, {{ allocItem.shipTo.state }}, {{ allocItem.shipTo.zip }}</p>
                    </dd>
                  </div>

                  <div class="py-2 sm:grid sm:grid-cols-3 sm:gap-4" v-show="allocItem.anticipatedDD !== null">
                    <dt class="text-sm leading-5 font-bold text-gray-500">
                      Estimated Delivery Date
                    </dt>
                    <dd class="pt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2 sm:border-t sm:border-grey">
                      {{ allocItem.anticipatedDD }}
                    </dd>
                  </div>

                  <div class="py-2 sm:grid sm:grid-cols-3 sm:gap-4" v-show="allocItem.poRequired">
                    <dt class="text-sm leading-5 font-bold text-gray-500">
                      PO Number
                    </dt>
                    <dd class="pt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2 sm:border-t sm:border-grey">
                      {{ allocItem.po }}
                    </dd>
                  </div>
                </dl>
              </li>
            </ul>
          </div>
        </div>

        <div style="text-align: center; color: #e10000;" class="toggle flex justify-center my-3 mx-2" v-if="errorMessage">
          {{errorMessage}}
        </div>

        <div v-show="order.isAdmin !== '2'"><!-- Do not show buttons if the order has already been voided -->
          <div class="actions flex justify-between p-4">
            <button @click.prevent="voidAlert" v-show="order.isAdmin === '1' || order.orderStatus === 1" class="rounded-full flex items-center text-base text-white border border-light-grey shadow-solid bg-red py-2 px-4 uppercase">
              Void order
              <svg class="ml-2 w-4" viewBox="0 0 448 512"><path fill="white" d="M296 432h16a8 8 0 0 0 8-8V152a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v272a8 8 0 0 0 8 8zm-160 0h16a8 8 0 0 0 8-8V152a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v272a8 8 0 0 0 8 8zM440 64H336l-33.6-44.8A48 48 0 0 0 264 0h-80a48 48 0 0 0-38.4 19.2L112 64H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v368a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V96h24a8 8 0 0 0 8-8V72a8 8 0 0 0-8-8zM171.2 38.4A16.1 16.1 0 0 1 184 32h80a16.1 16.1 0 0 1 12.8 6.4L296 64H152zM384 464a16 16 0 0 1-16 16H80a16 16 0 0 1-16-16V96h320zm-168-32h16a8 8 0 0 0 8-8V152a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v272a8 8 0 0 0 8 8z"/></svg>
            </button>
            
            <button @click.prevent="sendAdjustment()" type="submit" class="rounded-full flex items-center text-base text-white border border-light-grey shadow-solid bg-green py-2 px-4 uppercase">
              Save

              <svg class="ml-2 w-4" viewBox="0 0 512 512"><path fill="white" d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 464c-118.664 0-216-96.055-216-216 0-118.663 96.055-216 216-216 118.664 0 216 96.055 216 216 0 118.663-96.055 216-216 216zm141.63-274.961L217.15 376.071c-4.705 4.667-12.303 4.637-16.97-.068l-85.878-86.572c-4.667-4.705-4.637-12.303.068-16.97l8.52-8.451c4.705-4.667 12.303-4.637 16.97.068l68.976 69.533 163.441-162.13c4.705-4.667 12.303-4.637 16.97.068l8.451 8.52c4.668 4.705 4.637 12.303-.068 16.97z"/></svg>
            </button>
          </div>
        </div>

        <vue-modality
          ref="void"
          @ok="voidOrder"
          @cancel="$refs.myRef.hide()"
          title="VOID ORDER"
          centered
        >
          This will void order {{ order.id }}.
        </vue-modality>
      </div>
    </form>
  </div>  
</template>

<script>
import VueModality from 'vue-modality';
import qs from 'qs';

export default {
  name: 'OrderItems',
  props: {
    order: Object
  },
  components: {
    VueModality
  },
  data () {
    return {
      showModal: false,
      toggleAllocated: false,
      errorMessage: null
    }
  },
  mounted () {
    console.log(this.order);
    
    this.order.items.forEach(item => {
      item.originalQty = item.qty;
      this.order.allocations.forEach(allocation => {
        if (allocation.id == item.id) {
          item.allocated += allocation.qty;
        }
      })
    });
    console.log(this.order);
  },
  methods: {
    sendAdjustment () {
      let data = {};
      data['orderId'] = this.order.id;
      data.updatedItems = JSON.stringify(this.order.items);

      var isValidated = true;

      for (var rowIndex in this.order.items) {
        var row = this.order.items[rowIndex];

        var qtyDiff =  row.qty - row.originalQty;

        if (!isNaN(row.max) && qtyDiff > parseInt(row.max)) {
          isValidated = false;
          this.errorMessage = "Error: Quantity " + row.qty + " is higher than current stock of " + row.max + " for " + row.title;
        }
      }

      if (isValidated) {
        axios.post('/actions/ariq-module/send/adjust', data).then((res) => {
          this.resetEditing();
        })
        .catch((err) => {
          console.log(err);
        });
      }
      
    },
    voidAlert () {
      this.$refs.void.open();
    },
    voidOrder () {
      let data = {};
      data['orderId'] = this.order.id;

      axios.post('/actions/ariq-module/send/void', data).then((res) => {
        console.log(res);
        this.$refs.void.hide();
      })
      .catch((err) => {
        console.log(err);
      });
    },
    resetEditing () {
      this.order.items.forEach(item => {
        item.editing = false;
      });
      this.errorMessage = null;
    }
  },
  computed: {
    showAllocatedBtn() {
      console.log(this.order.allocations.length);
      return this.order.allocations.length;
    }

  }
}
</script>

<style lang="scss">

</style>